import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { IUserDataRow } from './HIDUsersTable'
import FullScreenLoader from '../Shared/FullScreenLoader'
import HIDCreateAccount from './HIDCreateAccount'
import {
  IOrigoAccount,
  GET_ORIGO_ACCOUNT,
  IGetOrigoAccountData,
  IGetOrigoAccountVars,
} from '../../graphql/hid/getOrigoAccount'
import { useLazyQuery, ApolloError } from '@apollo/client'
import HIDCards from './HIDCards'
import Error from '../Shared/Error'
import HIDCardSettings from './HIDCardSettings'
import { colors } from '../../const/colors'

interface IProps {
  userData: IUserDataRow
  listRefetch: () => void
}

const HIDAccount = ({ userData, listRefetch }: IProps) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [account, setAccount] = useState<IOrigoAccount>()
  const [requested, setRequested] = useState(false)
  const { login } = userData

  const [getMobileAccessAccount, { loading }] = useLazyQuery<
    IGetOrigoAccountData,
    IGetOrigoAccountVars
  >(GET_ORIGO_ACCOUNT, {
    variables: { login },
    fetchPolicy: 'no-cache',
    onError: (error: ApolloError) => setErrorMessage(error.message),
    onCompleted: (data: IGetOrigoAccountData) => {
      setAccount(data?.getUser.origoAccounts[0])
    },
  })

  useEffect(() => {
    getMobileAccessAccount()
  }, [])

  if (loading) {
    return <FullScreenLoader />
  }

  const refetchData = () => {
    getMobileAccessAccount()
    listRefetch()
  }

  return (
    <>
      {!account && (
        <HIDCreateAccount
          userData={userData}
          refetch={refetchData}
          requested={requested}
          onRequested={() => setRequested(true)}
        />
      )}
      {!!account && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Box
            sx={{
              pb: '16px',
              borderBottom: `1px solid ${colors.border}`,
            }}
          >
            <HIDCardSettings account={account} />
          </Box>
          <HIDCards userData={userData} refetch={refetchData} />
        </Box>
      )}

      {errorMessage && <Error errorMessage={errorMessage} />}
    </>
  )
}

export default HIDAccount
